import { ContactViewModel } from 'models/Contact';
import { UserViewModel } from 'models/User';

import { AttendeeCompany, AttendeeInteraction } from './types';

export const getCompanies = (attendingContacts: AttendeeCompany[]) => {
  const companies: string[] = [];
  attendingContacts.forEach((attendee) => companies.push(attendee.companyId));
  return companies;
};

export const getUnregisteredAttendees = (interaction: AttendeeInteraction) => {
  // get all registered users
  const users = [
    ...(interaction.attendingUsers ? interaction.attendingUsers : []),
    ...(interaction.attendingContacts ? interaction.attendingContacts : []),
  ];

  if (!interaction.attendees) {
    return [];
  }

  const unregistered = [...interaction.attendees].filter(
    (attendee) =>
      !!users.find((user) => {
        const emails = user?.emails || [];
        const phone = user?.phone || [];
        return emails.includes(attendee) || phone.includes(attendee);
      }),
  );

  return unregistered;
};

// Returns the attendees contact phone or email (which ever is populated)
export const getAttendeeContact = (
  attendingContact: UserViewModel | ContactViewModel,
) => {
  const phone: string[] = attendingContact?.phone || [];
  if (phone.length > 0) {
    return phone[0];
  }
  const emails: string[] = attendingContact?.emails || [];
  if (emails.length > 0) {
    return emails[0];
  }

  return undefined;
};
